
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  props: {
    count: { type: [String, Number], required: false },
    label: { type: String, required: true },
    iconClass: {
      type: [Array, String] as PropType<string[] | string>,
      required: true
    }
  }
})
